/**
 * قراءة متغيرات البيئة في مكان واحد مع تحقق واضح عند الإقلاع.
 *
 * قاعدة أمنية: كل ما يبدأ بـ VITE_ يُدمج في حزمة الواجهة ويكون مرئيًا للمستخدم،
 * لذلك لا يجوز أن يحتوي أي سر (مثل service role) على بادئة VITE_ إطلاقًا.
 * الأسرار الخادمية تُضبط عبر أسرار Supabase/الخادم، لا في هذا الملف.
 */

export type DataMode = 'local' | 'supabase';

function read(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

const rawMode = read(import.meta.env.VITE_DATA_MODE).toLowerCase();
if (rawMode && rawMode !== 'local' && rawMode !== 'supabase') {
  throw new Error(
    `قيمة VITE_DATA_MODE غير صحيحة: "${rawMode}". القيم المسموحة: local أو supabase.`,
  );
}

export const env = {
  /** الطبقة النشطة للبيانات. الافتراضي local ليعمل التطبيق دون خدمات خارجية. */
  dataMode: (rawMode || 'local') as DataMode,
  supabaseUrl: read(import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: read(import.meta.env.VITE_SUPABASE_ANON_KEY),
  authRedirectUrl: read(import.meta.env.VITE_AUTH_REDIRECT_URL),
  defaultTimeZone: read(import.meta.env.VITE_DEFAULT_TIME_ZONE) || 'Asia/Riyadh',
  /** هل نعمل داخل غلاف Electron؟ الواجهة preload تكشف ذلك بأمان. */
  isDesktop: typeof window !== 'undefined' && Boolean(window.taskflowDesktop?.isDesktop),
} as const;
